import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxBadge } from '@onyx/angular';
import { OnyxBadgeComponent } from '@onyx/angular';
import type { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-roles-cell',
  imports: [OnyxBadgeComponent, TranslatePipe],
  templateUrl: './badges-cell.component.html',
  styleUrl: './badges-cell.component.scss',
})
export class BadgesCellComponent<T> {
  public readonly badges = input.required<OnyxBadge<T>[] | null>();
  public readonly dictionaryCode = input.required<DictionaryCode>();
}
